export const USER_FULLNAME_SYSTEM = 'System.SystemUserFullnameKey'

export const CHAT_PARTICIPANTS_OPTIONS_API_PARAMS = {
  status: 'active',
}

// Actions shared by more than one user-profile surface (header footer +
// icon bar). Surface-specific actions are defined in that surface's own
// constants by extending these.
export const USER_PROFILE_ACTION = {
  addNew: 'addNew',
  archive: 'archive',
  block: 'block',
  contract: 'contract',
  delete: 'delete',
  folder: 'folder',
  restore: 'restore',
  sendInvite: 'sendInvite',
  serviceRequest: 'serviceRequest',
  unblock: 'unblock',
  upload: 'upload',
}

// `addNew` has no permission entry — it is a container whose options
// are gated individually.
export const USER_PROFILE_ACTION_PERMISSION = {
  [USER_PROFILE_ACTION.archive]: 'can_delete',
  [USER_PROFILE_ACTION.block]: 'can_block_user',
  [USER_PROFILE_ACTION.contract]: 'can_manage_all_user_flats',
  [USER_PROFILE_ACTION.delete]: 'can_delete',
  [USER_PROFILE_ACTION.folder]: 'can_edit_files',
  [USER_PROFILE_ACTION.restore]: 'can_restore',
  [USER_PROFILE_ACTION.sendInvite]: 'can_send_invite',
  [USER_PROFILE_ACTION.serviceRequest]: 'can_create_request',
  [USER_PROFILE_ACTION.unblock]: 'can_unblock_user',
  [USER_PROFILE_ACTION.upload]: 'can_edit_files',
}

export const USER_FORM_FIELD_NAME_BUILDING = 'building'

export const USER_FORM_FIELD_NAME_CONTRACT_END = 'contractEnd'

export const USER_FORM_FIELD_NAME_EMAIL = 'email'

export const USER_FORM_FIELD_NAME_EXTERNAL_ID = 'externalId'

export const USER_FORM_FIELD_NAME_FIRST_NAME = 'firstName'

export const USER_FORM_FIELD_NAME_FLAT = 'flat'

export const USER_FORM_FIELD_NAME_LAST_NAME = 'lastName'

export const USER_FORM_FIELD_NAME_MESSAGE = 'message'

export const USER_FORM_FIELD_NAME_PHONE = 'phone'

export const USER_FORM_FIELD_NAME_ROLE = 'role'

export const USER_FORM_FIELD_NAME_SEND_INVITATION = 'sendInvitation'

export const USER_FORM_FIELD_NAME_SEND_SMS_INVITATION = 'send_sms'

export const USER_FORM_EMAIL_FIELD_MAX_LENGTH = 128

export const USER_FORM_EXTERNAL_ID_FIELD_MAX_LENGTH = 255

export const USER_FORM_FIRST_NAME_FIELD_MAX_LENGTH = 160

export const USER_FORM_LAST_NAME_FIELD_MAX_LENGTH = 160

export const USER_FORM_PHONE_FIELD_MAX_LENGTH = 15

export const USER_FORM_SERVER_ERROR_INVITATION_MESSAGE_TOO_LONG_VALUE_PREFIX =
  'Ensure_this_field_has_no_more_than'

export const USER_FORM_MOBILE_ACTIONS_MAX_WIDTH = 700 //px

export const UserProfileTabId = {
  Attributes: 'attributes',
  Buildings: 'buildings',
  Categories: 'categories',
  Contracts: 'contracts',
  Documents: 'documents',
  Emails: 'emails',
  Posts: 'posts',
  Requests: 'requests',
  Updates: 'updates',
}
